// Display mirror of the law review package F catalogues (backend lib/ropaParticulars.ts, lib/rightsRequests.ts,
// lib/breachContent.ts, lib/dpAgreements.ts). backend lib/__tests__/dpRegistersLawReview.test.ts keeps the ids
// identical. The server validates every value; these only label the pickers.

export const LAWFUL_BASES = [
  { id: "consent",                         label: "Consent",                         ukOnly: false },
  { id: "contract",                        label: "Contract",                        ukOnly: false },
  { id: "legal_obligation",                label: "Legal obligation",                ukOnly: false },
  { id: "vital_interests",                 label: "Vital interests",                 ukOnly: false },
  { id: "public_task",                     label: "Public task",                     ukOnly: false },
  { id: "recognised_legitimate_interests", label: "Recognised legitimate interests (UK)", ukOnly: true },
  { id: "legitimate_interests",            label: "Legitimate interests",            ukOnly: false },
];

export const ART9_CONDITIONS = [
  { id: "a", label: "(a) Explicit consent" },
  { id: "b", label: "(b) Employment, social security and social protection law" },
  { id: "c", label: "(c) Vital interests where consent cannot be given" },
  { id: "d", label: "(d) Not-for-profit body, its members and contacts" },
  { id: "e", label: "(e) Made manifestly public by the person" },
  { id: "f", label: "(f) Legal claims or courts acting judicially" },
  { id: "g", label: "(g) Substantial public interest, on a basis in law" },
  { id: "h", label: "(h) Health or social care" },
  { id: "i", label: "(i) Public health" },
  { id: "j", label: "(j) Archiving, research or statistics" },
];

export const ART10_BASES = [
  { id: "official_authority", label: "Under the control of official authority" },
  { id: "authorised_by_law",  label: "Authorised by law providing safeguards (for UK law: a Schedule 1 condition)" },
];

export const UK_SCHEDULE1_CONDITIONS = [
  { id: "p1", label: "Para 1 Employment, social security and social protection" },
  { id: "p2", label: "Para 2 Health or social care purposes" },
  { id: "p3", label: "Para 3 Public health" },
  { id: "p4", label: "Para 4 Research etc" },
  { id: "p6", label: "Para 6 Statutory etc and government purposes" },
  { id: "p7", label: "Para 7 Administration of justice and parliamentary purposes" },
  { id: "p8", label: "Para 8 Equality of opportunity or treatment" },
  { id: "p9", label: "Para 9 Racial and ethnic diversity at senior levels" },
  { id: "p10", label: "Para 10 Preventing or detecting unlawful acts" },
  { id: "p11", label: "Para 11 Protecting the public" },
  { id: "p12", label: "Para 12 Regulatory requirements" },
  { id: "p13", label: "Para 13 Journalism etc in connection with unlawful acts" },
  { id: "p14", label: "Para 14 Preventing fraud" },
  { id: "p15", label: "Para 15 Suspicion of terrorist financing or money laundering" },
  { id: "p16", label: "Para 16 Support for individuals with a particular disability or medical condition" },
  { id: "p17", label: "Para 17 Counselling etc" },
  { id: "p18", label: "Para 18 Safeguarding of children and individuals at risk" },
  { id: "p19", label: "Para 19 Safeguarding of economic well-being of certain individuals" },
  { id: "p20", label: "Para 20 Insurance" },
  { id: "p21", label: "Para 21 Occupational pensions" },
  { id: "p22", label: "Para 22 Political parties" },
  { id: "p23", label: "Para 23 Elected representatives responding to requests" },
  { id: "p24", label: "Para 24 Disclosure to elected representatives" },
  { id: "p25", label: "Para 25 Informing elected representatives about prisoners" },
  { id: "p26", label: "Para 26 Publication of legal judgments" },
  { id: "p27", label: "Para 27 Anti-doping in sport" },
  { id: "p28", label: "Para 28 Standards of behaviour in sport" },
  { id: "p29", label: "Para 29 Consent (criminal offence data)" },
  { id: "p30", label: "Para 30 Protecting individual's vital interests" },
  { id: "p31", label: "Para 31 Processing by not-for-profit bodies" },
  { id: "p32", label: "Para 32 Personal data in the public domain" },
  { id: "p33", label: "Para 33 Legal claims" },
  { id: "p34", label: "Para 34 Judicial acts" },
  { id: "p36", label: "Para 36 Extension of Part 2 conditions" },
  { id: "p37", label: "Para 37 Extension of insurance conditions" },
];

export const TRANSFER_MECHANISMS = [
  { id: "adequacy",    label: "Adequacy decision / UK adequacy regulations" },
  { id: "sccs_eu",     label: "EU standard contractual clauses" },
  { id: "idta",        label: "UK International Data Transfer Agreement" },
  { id: "uk_addendum", label: "UK Addendum to the EU SCCs" },
  { id: "bcr",         label: "Binding corporate rules" },
  { id: "derogation",  label: "Derogation for a specific situation (Art. 49)" },
  { id: "other",       label: "Other safeguard (described below)" },
];
/** Tools a transfer risk assessment is expected for. */
export const TRA_MECHANISMS = new Set(["sccs_eu", "idta", "uk_addendum", "bcr"]);

export const ART49_DEROGATIONS = [
  { id: "a", label: "(a) Explicit consent after being told the risks" },
  { id: "b", label: "(b) Necessary for a contract with the person" },
  { id: "c", label: "(c) Necessary for a contract in the person's interest" },
  { id: "d", label: "(d) Important reasons of public interest" },
  { id: "e", label: "(e) Legal claims" },
  { id: "f", label: "(f) Vital interests where consent cannot be given" },
  { id: "g", label: "(g) From a public register" },
  { id: "compelling_legitimate_interests", label: "Compelling legitimate interests (Art. 49(1), second subparagraph)" },
];

export const ART34_EXEMPTIONS = [
  { id: "a", label: "(a) The data was unintelligible to anyone not authorised (for example encrypted)" },
  { id: "b", label: "(b) Measures taken since mean the high risk is no longer likely" },
  { id: "c", label: "(c) Telling each person would take disproportionate effort; a public communication was made instead" },
];

export const BREACH_ORG_ROLES = [
  { id: "controller", label: "We are the controller" },
  { id: "processor",  label: "We process it for a customer (processor)" },
  { id: "both",       label: "Both: some as controller, some for customers" },
];

export const REQUEST_TYPE_LABELS: Record<string, string> = {
  access: "Access", rectification: "Rectification", erasure: "Erasure", restriction: "Restriction", portability: "Portability",
  objection: "Objection", automated_decision: "Automated decision-making", consent_withdrawal: "Withdrawal of consent",
  opt_out_sale_sharing: "Opt out of sale or sharing", limit_sensitive: "Limit use of sensitive personal information",
  appeal: "Appeal against a refused request",
};
export const ART19_REQUEST_TYPES = new Set(["rectification", "erasure", "restriction"]);
export const RECIPIENTS_NOTIFIED = [
  { id: "yes",                            label: "Yes, each recipient was told" },
  { id: "not_applicable",                 label: "Not applicable: the data was not disclosed to anyone" },
  { id: "impossible_or_disproportionate", label: "Impossible or would take disproportionate effort (say why)" },
];
export const EXTENSION_REASONS = [
  { id: "complexity",         label: "The request is complex" },
  { id: "number_of_requests", label: "The number of requests received" },
];

export const DP_AGREEMENT_KINDS = [
  { id: "processor_agreement",          label: "Processor agreement (we are the processor)" },
  { id: "joint_controller_arrangement", label: "Joint controller arrangement (Art. 26)" },
  { id: "data_sharing",                 label: "Data sharing agreement" },
  { id: "transfer_tool",                label: "Transfer tool (SCCs, IDTA, UK Addendum)" },
  { id: "transfer_risk_assessment",     label: "Transfer risk assessment" },
];
export const dpAgreementKindLabel = (id: string) => DP_AGREEMENT_KINDS.find((k) => k.id === id)?.label ?? id;
